/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Spinner, Modal, Button } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import Select from 'react-select';
import * as userService from '../../../../services/management/userService';
import * as helper from '../../../../helpers/helper';
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as proposalService from '../../../../services/service/proposalService';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Countdown from 'react-countdown';
import * as confirmModal from '../../../../redux/confirmModalRedux';
import constants from '../../../../constants/constants';

const ProposalManageCard = (props) => {
  const {
    history,
    proposalId,
    proposal,
    showAlert,
    auth,
    proposalPermission,
    showConfirmModal,
    hideConfirmModal,
    updateProposalPermission,
    setProcessing,
  } = props;
  const [showModal, setShowModal] = useState(false);
  const [showSendToClientModal, setShowSendToClientModal] = useState(false);
  const [dueDate, setDueDate] = useState(null);
  const [saving, setSaving] = useState(false);
  const [savedDueDate, setSavedDueDate] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userList, setUserList] = useState([]);
  const [addExtension, setAddExtension] = useState(false);
  const [sentToClient, setSentToClient] = useState(false);
  const [sending, setSending] = useState(false);
  const [sendToClientInfo, setSendToClientInfo] = useState({
    emails: null,
    proposalFiles: null,
  });

  const [deadLinePreSets, setDeadLinePreSets] = useState([
    { name: 'Immediate (Upto 4 hours)', value: 4 },
    { name: '12 hours', value: 12 },
    { name: '24 hours', value: 24 },
    { name: '48 hours', value: 48 },
  ]);

  useEffect(() => {
    userService.getAllUsers(false).then((res) => {
      let allUsers = res.map((x) => {
        return { ...x, role: x.role.split(',') };
      });
      allUsers = allUsers.filter((x) => (x.role.includes('Admin') || x.role.includes('Project Manager')) && x.id != auth.user.id);
      var options = allUsers.map((x) => helper.setToOptionModel(x.fullName, x.id));
      setUserList(options);

      fetchProposalReviewers(options);
    });
  }, []);

  useEffect(() => {
    if (userList.length > 0) {
      fetchProposalReviewers(userList);
    }
  }, [showModal]);

  const countDownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      return <span>The review period for this proposal has ended.</span>;
    } else {
      // Render a countdown
      return (
        <span>
          {days} days {hours} hr {minutes} min {seconds} sec
        </span>
      );
    }
  };

  const fetchProposalReviewers = (options) => {
    proposalService.GetProposalReviewers(proposalId).then((res) => {
      if (res.length > 0) {
        setSavedDueDate(moment(res[0].reviewDeadLineDateTime).format('MM/DD/YYYY hh:mm a'));
        setDueDate(1);
        let allReviewersId = res.map((x) => x.userId);
        let tempSelection = [];
        allReviewersId.forEach((x) => {
          tempSelection.push(options.find((y) => y.value === x));
        });

        setSelectedUsers(tempSelection);
      }
    });
  };

  const assignReviewers = () => {
    setSaving(true);
    if (selectedUsers.length == 0) {
      showAlert({ message: 'Error! Please select at least one reviewer before submitting for review', variant: 'error' });
      return;
    }
    if (dueDate) {
      proposalService
        .SaveProposalReviewers({
          id: proposalId,
          noOfHoursForDueDate: dueDate.value,
          userIdForReview: selectedUsers.map((x) => x.value),
          projectNumber: proposal.projectNumber,
        })
        .then((res) => {
          showAlert({ message: 'Success! Reviewers has successfully been assigned to the proposal', variant: 'success' });
          setShowModal(false);
          setSaving(false);
        });
    }
  };

  const handleModalClose = () => {
    setAddExtension(false);
    setShowModal(false);
  };

  const confirmProposalReview = () => {
    setProcessing();
    proposalService
      .SetProposalAsReviewed(proposalId, auth.user.id)
      .then((res) => {
        if (res.success) {
          updateProposalPermission({
            ...proposalPermission,
            hasReviewed: true,
            dateReviewed: moment().format('MM/DD/YYYY hh:mm a'),
          });
          showAlert({ message: 'Success! You have successfully reviewed the proposal.', variant: 'success' });
        }
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
      })
      .finally(() => hideConfirmModal());
  };

  const showExtensionToggle = () => {
    if (!addExtension) {
      setAddExtension(true);
      return;
    }

    if (dueDate === 1) {
      showAlert({ message: 'Error! Please Select Extension Period.', variant: 'error' });
      return;
    }

    proposalService
      .AddExtension(proposalId, dueDate.value)
      .then((res) => {
        showAlert({ message: res.message, variant: 'success' });
        handleModalClose();
        setSaving(false);
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
      });
  };

  const openSendToClientModal = () => {
    proposalService
      .GetProposalSendInfo(proposalId)
      .then((res) => {
        setShowSendToClientModal(true);
        if (res === null) {
          sentToClient(true);
        } else {
          setSendToClientInfo(res);
        }
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
      });
  };

  const sendToClient = () => {
    setSending(true);
    proposalService
      .SendProposalToClient(proposalId)
      .then((res) => {
        history.push('/services/proposals');
        showAlert({ message: res.message, variant: 'success' });
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
        setSending(false);
      });
  };

  return (
    <>
      <Modal size='lg' show={showSendToClientModal} onHide={() => setShowSendToClientModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Send To Client</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {sentToClient ? (
            <h3>This proposal has already been sent to client.</h3>
          ) : (
            <>
              <p className='font-weight-bolder fz-xs'>
                Are you sure you want to send this proposal to client? Please review the details below:{' '}
              </p>
              <div className='container'>
                <p>Emails</p>
                <ul>
                  {sendToClientInfo.emails ? (
                    sendToClientInfo.emails.map((x, i) => <li key={i}>{x}</li>)
                  ) : (
                    <p>No Emails. Please enter an email</p>
                  )}
                </ul>
                <p>Files</p>
                <ul>
                  {sendToClientInfo.proposalFiles ? (
                    sendToClientInfo.proposalFiles.map((x, i) => <li key={i}>{x.name}</li>)
                  ) : (
                    <p>No Files are set to be sent to client </p>
                  )}
                </ul>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <a
            className='btn btn-info'
            href={constants.API_URL + 'api/Proposal/GetProposalPdf?proposalId=' + proposalId + '&token=' + auth.authToken}
            target='_blank'
            rel='noreferrer'
          >
            Preview Form
          </a>
          <Button variant='warning' onClick={sendToClient} disabled={sending}>
            {sending ? <Spinner size='sm' animation='border' variant='primary' /> : 'Send To Client'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal size='lg' show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Assign Reviewers</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {addExtension ? (
            <div className='form-group row'>
              <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Extension Period</label>
              <div className='col-lg-9 col-xl-9'>
                <Select
                  placeholder='Select Review Duration'
                  value={dueDate}
                  options={deadLinePreSets.map((x) => helper.setToOptionModel(x.name, x.value))}
                  onChange={(selectedOption) => {
                    selectedOption = selectedOption === null ? [] : selectedOption;
                    setDueDate(selectedOption);
                  }}
                />
              </div>
            </div>
          ) : (
            <>
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Due Date</label>
                <div className='col-lg-9 col-xl-9'>
                  {savedDueDate ? (
                    <Typography variant='h5' gutterBottom style={{ marginTop: '10px' }}>
                      {savedDueDate}
                    </Typography>
                  ) : (
                    <Select
                      placeholder='Select Review Duration'
                      value={dueDate}
                      options={deadLinePreSets.map((x) => helper.setToOptionModel(x.name, x.value))}
                      onChange={(selectedOption) => {
                        selectedOption = selectedOption === null ? [] : selectedOption;
                        setDueDate(selectedOption);
                      }}
                    />
                  )}
                </div>
              </div>
              {savedDueDate && (
                <div className='form-group row'>
                  <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Remaining Time</label>
                  <div className='col-lg-9 col-xl-9'>
                    <Typography variant='h5' gutterBottom style={{ marginTop: '10px' }}>
                      <Countdown date={savedDueDate} renderer={countDownRenderer} />
                    </Typography>
                  </div>
                </div>
              )}
              <div className='form-group row'>
                <label className='col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Reviewers</label>
                <div className='col-lg-9 col-xl-9'>
                  <Select
                    value={selectedUsers}
                    options={userList}
                    isDisabled={moment(savedDueDate).diff(moment()) < 0}
                    isMulti
                    closeMenuOnSelect={false}
                    menuPlacement={'auto'}
                    onChange={(selectedOption) => {
                      selectedOption = selectedOption === null ? [] : selectedOption;
                      setSelectedUsers(selectedOption);
                    }}
                    name='reviewers'
                    placeholder='Select Reviewers'
                  />
                </div>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleModalClose}>
            Close
          </Button>
          {moment(savedDueDate).diff(moment()) > 0 || savedDueDate == null ? (
            <Button variant='primary' disabled={saving} onClick={assignReviewers}>
              Save Changes
            </Button>
          ) : (
            <Button variant='warning' disabled={saving} onClick={() => showExtensionToggle()}>
              Add Extension
            </Button>
          )}
        </Modal.Footer>
      </Modal>
      <div className='aes-proposal-manage-sidebar flex-row-auto offcanvas-mobile w-250px w-xxl-350px' id='kt_profile_aside'>
        <div className='card card-custom card-stretch'>
          <div className='card-body pt-4'>
            <div className='d-flex align-items-center'>
              <div>
                <a
                  href='#'
                  className='font-weight-bolder font-size-h3 text-dark-75 text-hover-primary'
                  onClick={() => {
                    proposal.jobId && history.push('/services/manage-job/general-information/' + proposal.jobId);
                  }}
                >
                  Project #{proposal.projectNumber}
                </a>
              </div>
            </div>
            <div className='py-9'>
              <div className='d-flex align-items-center justify-content-between flex-wrap mb-2'>
                <span className='font-weight-bold mr-2'>Created By:</span>
                <span className='text-muted text-hover-primary'>{proposal.createdBy}</span>
              </div>
              <div className='d-flex align-items-center justify-content-between flex-wrap mb-2'>
                <span className='font-weight-bold mr-2'>Created On: </span>
                <span className='text-muted'>{proposal.createdOn}</span>
              </div>
              <div className='d-flex align-items-center justify-content-between flex-wrap mb-2'>
                <span className='font-weight-bold mr-2'>Last Updated By:</span>
                <span className='text-muted text-hover-primary'>{proposal.updatedBy}</span>
              </div>
              <div className='d-flex align-items-center justify-content-between flex-wrap mb-2'>
                <span className='font-weight-bold mr-2'>Last Updated On: </span>
                <span className='text-muted'>{proposal.updatedOn}</span>
              </div>
              {proposal.submittedBy === '-' ? (
                proposalPermission.userRole != 'Reviewer' && (
                  <div className='mt-2'>
                    <button
                      href='#'
                      onClick={openSendToClientModal}
                      className='btn btn-sm btn-success font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1'
                    >
                      Send To Client
                    </button>

                    <button
                      onClick={() => setShowModal(true)}
                      className='btn btn-sm btn-info font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1'
                    >
                      Send For Review
                    </button>
                  </div>
                )
              ) : (
                <>
                  <div className='d-flex align-items-center justify-content-between flex-wrap mb-2'>
                    <span className='font-weight-bold mr-2'>Submitted By: </span>
                    <span className='text-muted'>{proposal.submittedBy}</span>
                  </div>
                  <div className='d-flex align-items-center justify-content-between flex-wrap mb-2'>
                    <span className='font-weight-bold mr-2'>Submitted On: </span>
                    <span className='text-muted'>{proposal.submittedOn}</span>
                  </div>
                </>
              )}
              {proposalPermission.dateReviewed ? (
                <button className='btn btn-sm btn-info font-weight-bold btn-block'>
                  <i className='ki ki-bold-check icon-sm' /> Review completed on {proposalPermission.dateReviewed}
                </button>
              ) : (
                (proposalPermission.userRole == 'Reviewer' || proposalPermission.userRole == 'AdminReviewer') &&
                !proposalPermission.hasReviewed && (
                  <div className='mt-2'>
                    <a
                      href='#'
                      onClick={() =>
                        showConfirmModal({
                          title: 'Confirm Review',
                          text: `<strong>Are you sure you want to confirm the review for this proposal?</strong>
                                            <p>Once you review this proposal, notification will be sent out to the reviewers log</p>`,
                          rightBtnText: 'Confirm',
                          btnAction: () => confirmProposalReview(),
                        })
                      }
                      className='btn btn-sm btn-success font-weight-bold btn-block'
                    >
                      <i className='ki ki-bold-check icon-sm' /> Complete Review
                    </a>
                  </div>
                )
              )}
            </div>
            <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
              <div className='navi-item mb-2'>
                <NavLink
                  to={'/services/manage-proposal/general-information/' + proposalId}
                  className='navi-link py-4'
                  activeClassName='active'
                >
                  <span className='navi-icon mr-2'>
                    <span className='svg-icon'>
                      <SVG src={toAbsoluteUrl('/media/svg/icons/Design/Layers.svg')}></SVG>{' '}
                    </span>
                  </span>
                  <span className='navi-text font-size-lg'>General Information</span>
                </NavLink>
              </div>
              <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
                <div className='navi-item mb-2'>
                  <NavLink
                    to={'/services/manage-proposal/proposal-content/' + proposalId}
                    className='navi-link py-4'
                    activeClassName='active'
                  >
                    <span className='navi-icon mr-2'>
                      <span className='svg-icon'>
                        <SVG src={toAbsoluteUrl('/media/svg/icons/Files/Selected-file.svg')}></SVG>{' '}
                      </span>
                    </span>
                    <span className='navi-text font-size-lg'>Proposal Content</span>
                  </NavLink>
                </div>
              </div>
              <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
                <div className='navi-item mb-2'>
                  <NavLink
                    to={'/services/manage-proposal/proposal-estimator/' + proposalId}
                    className='navi-link py-4'
                    activeClassName='active'
                  >
                    <span className='navi-icon mr-2'>
                      <span className='svg-icon'>
                        <SVG src={toAbsoluteUrl('/media/svg/icons/Shopping/Dollar.svg')}></SVG>{' '}
                      </span>
                    </span>
                    <span className='navi-text font-size-lg'>Proposal Estimator</span>
                  </NavLink>
                </div>
              </div>
              <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
                <div className='navi-item mb-2'>
                  <NavLink to={'/services/manage-proposal/contact-logs/' + proposalId} className='navi-link py-4' activeClassName='active'>
                    <span className='navi-icon mr-2'>
                      <span className='svg-icon'>
                        <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Address-card.svg')}></SVG>{' '}
                      </span>
                    </span>
                    <span className='navi-text font-size-lg'>Contact Logs</span>
                  </NavLink>
                </div>
              </div>
              <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
                <div className='navi-item mb-2'>
                  <NavLink to={'/services/manage-proposal/attachments/' + proposalId} className='navi-link py-4' activeClassName='active'>
                    <span className='navi-icon mr-2'>
                      <span className='svg-icon'>
                        <SVG src={toAbsoluteUrl('/media/svg/icons/Files/Folder-solid.svg')}></SVG>{' '}
                      </span>
                    </span>
                    <span className='navi-text font-size-lg'>Attachments</span>
                  </NavLink>
                </div>
              </div>
              <div className='navi navi-bold navi-hover navi-active navi-link-rounded'>
                <div className='navi-item mb-2'>
                  <NavLink to={'/services/manage-proposal/reviewer-logs/' + proposalId} className='navi-link py-4' activeClassName='active'>
                    <span className='navi-icon mr-2'>
                      <span className='svg-icon'>
                        <SVG src={toAbsoluteUrl('/media/svg/icons/Communication/Group-chat.svg')}></SVG>{' '}
                      </span>
                    </span>
                    <span className='navi-text font-size-lg'>Reviewer Logs</span>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  userProfileState: state.userProfile,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  ...alert.actions,
  ...confirmModal.actions,
})(ProposalManageCard);
